//Only thing using this is custom cats.  Either go through and update it to not use this or bin it off completely
const financeTypes = {
	if: 'InterestFree',
	bnpl: 'BuyNowPayLater',
};

export const getFinanceData = (imageName, price) => {
	if (typeof imageName !== 'string') {
		return null;
	}

	const duration = imageName.match(/\d+/);

	return {
		type: financeTypes[
			Object.keys(financeTypes).filter((item) => imageName.includes(item))[0]
		],
		duration: duration ? duration[0] : null,
		monthlyPrice:
			duration && price
				? (Math.ceil((price / duration[0]) * 100) / 100).toFixed(2)
				: null,
	};
};

export const getFinanceButtonConfig = (financePromotion) => {
	if (!financePromotion || !financePromotion.PromotionType) return null;

	switch (financePromotion.PromotionType) {
		case 'InterestFreeCredit':
			return {
				promoText: `${financePromotion.PromotionMonths} months 0% interest available`,
				testId: 'finance-interest-free',
				label: 'Interest Free Finance Promotion',
			};
		case 'BuyNowPayLater':
			return {
				promoText: `Buy now, pay in ${financePromotion.PromotionMonths} months`,
				testId: 'finance-buy-now-pay-later',
				label: 'Buy Now Pay Later Finance Promotion',
			};
		case 'FourPointNinePercent':
			return {
				promoText: `${financePromotion.PromotionMonths} months 4.9% interest available`,
				testId: 'finance-four-point-nine-percent',
				label: 'Four Point Nine Percent Finance Promotion',
			};
		case 'NinePointNinePercent':
			return {
				promoText: `${financePromotion.PromotionMonths} months 9.9% interest available`,
				testId: 'finance-nine-point-nine-percent',
				label: 'Nine Point Nine Percent Finance Promotion',
			};
		default:
			return null;
	}
};

export const buildSlideoutPayload = ({
	ColourId,
	Code,
	NowPrice,
	MemberPrice,
	AnnualMembershipFee,
	PromotionType,
	PromotionMonths,
	FinancePromotions,
	State,
	UpfrontPricing,
	Switch24Pricing,
	UseUpfrontPricingAmounts,
	UseSwitch24,
	representativeAprRateString,
	purchaseAprRateString,
}) => ({
	productId: ColourId,
	productSku: Code,
	nowPrice: NowPrice,
	memberPrice: MemberPrice,
	annualMembershipFee: AnnualMembershipFee,
	financePromotionType: PromotionType,
	financePromotionMonths: PromotionMonths,
	financePromotionCodes: FinancePromotions?.map((p) => p.PromotionCode) || [],
	isInStock: State !== 'OutOfStock',
	memberUpfrontPaymentAmount: UpfrontPricing?.MemberUpfrontPaymentAmount,
	upfrontPaymentAmount: UpfrontPricing?.UpfrontPaymentAmount,
	upfrontPaymentPercentage: UpfrontPricing?.UpfrontPaymentPercentage,
	upfrontPaymentsEnabled: UseUpfrontPricingAmounts,
	switch24Pricing: Switch24Pricing,
	isSwitch24Enabled: UseSwitch24,
	representativeAprRateString,
	purchaseAprRateString,
});
